import { APPOINTMENT_AMENDABLE_STATUSES } from 'features/order-tracker/store/sagas/services/helpers/constants';
import { APPOINTMENT_TYPES } from 'features/order-tracker/utils/entries';
import { CONTACT_US_INFO_TYPE } from 'features/order-tracker/utils/entries/contactUsInfoType';

// eslint-disable-next-line no-unused-vars
import { AppointmentStrategy } from './AppointmentStrategy';

export class ExpertSetupAppointmentStrategy implements AppointmentStrategy {
  getInfoType = (appointment: common.EngineerAppointment): common.ContactUsInfo | null => {
    if (appointment.isDateLessThan24Hours) {
      return CONTACT_US_INFO_TYPE.ForbidToAmend;
    }
    return null;
  };

  isReminderAvailable = (appointment: common.EngineerAppointment): boolean =>
    APPOINTMENT_AMENDABLE_STATUSES.includes(appointment.status);

  isSiteContactAvailable = (appointment: common.EngineerAppointment): boolean => !!appointment.siteContact;

  isAmendable = (): boolean => false;

  isApplicable = (appointment: common.EngineerAppointment): boolean => appointment.type === APPOINTMENT_TYPES.expert;

  isHelpSectionAvailable = (): boolean => false;
}
